import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentSolicitacaoFluxoDefinirOrcamento from './ContentSolicitacaoFluxoDefinirOrcamento';

const SolicitacaoFluxoDefinirOrcamento = () => {
  return (
    <>
      <HeaderApp />
      <ContentSolicitacaoFluxoDefinirOrcamento />
      <Bottom />
    </>
  );
};

export default SolicitacaoFluxoDefinirOrcamento;
